var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding-guide"},[_c('Guide',{attrs:{"content":_vm.content,"contentVideo":_vm.contentVideo,"contentHeading":"Website Appearance - Fonts","closeLink":_vm.closeLink,"nextLink":_vm.nextLink,"previousLink":_vm.previousLink}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }